'use strict';

+function ($) {

  $(document)
  // prevent browser's default # navigation if there's no link on a dropdown-menu item
  .on('click.bc.dropdown', '.dropdown-menu a[href="#"]', function (e) {
    e.preventDefault();
  })

  // selecting an option from the dropdown-menu
  .on('click.bc.dropdown', '[data-dropdown] .dropdown-menu a', function (e) {
    var $option = $(e.target).closest('a') || $(e.target);
    var $dropdown = $option.closest('[data-dropdown]');
    var $button = $dropdown.find('button');
    var label = $option.text();
    var value = $option.data('value');
    // dynamically update label on fake "select" button and return focus to button
    if ($button.length > 0) {
      if (typeof $option.data('label') !== 'undefined') {
        label = $option.data('label');
      }
      $button.html(function (index, oldHtml) {
        return oldHtml.replace(/^[^<]+/, label);
      });
      // .focus(); // this causes complications if you trigger change then it triggers click and then this focus causes the page to scroll - trigger change shouldn't cause a scroll jump
    }
    // dynamically update value of a hidden form field
    if (typeof value === 'undefined') {
      value = label;
    }
    // blur to trigger validation
    $dropdown.find(':input').val(value).trigger('blur');
  })

  // when the hidden input changes, update the dropdown's displayed value
  .on('change.bc.dropdown', '[data-dropdown] :input', function () {
    var $dropdown = $(this).closest('[data-dropdown]');
    var $option = $dropdown.find('.dropdown-menu [data-value="' + $(this).val() + '"]');
    if ($option.length < 1) {
      $option = $dropdown.find('.dropdown-menu li:first a:first');
    }
    $option.trigger('click');
  });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/dropdown.js
// module id = 6
// module chunks = 0